import script from "./error500.vue?vue&type=script&setup=true&name=error500&lang=js"
export * from "./error500.vue?vue&type=script&setup=true&name=error500&lang=js"

const __exports__ = script;

export default __exports__